import React from "react";
import { Box } from "lucide-react"; 
const BoxComponent = ({
  value,
  label,
  cardBg,
    iconColor = "#404040",  
  iconBg = "#fff",        
  className = "",
}) => {
  return (
    <div
      className={`flex items-center justify-between p-4 rounded-xl shadow-sm border border-gray-300 ${className}`}
      style={{ backgroundColor: cardBg }}
    >
      <div className="flex flex-col">
        <span className="text-[24px] text-[#404040;] font-semibold leading-none">{value}</span>
        <span className="text-[12px] text-[#000] mt-1">{label}</span>
      </div>

     <div
        className="ml-4 w-[65px] h-[65px] flex items-center justify-center rounded-md"
        style={{ backgroundColor: iconBg }}
      >
        <Box  size={32} color={iconColor} />
      </div>
    </div>
  );
};

export default BoxComponent;
